import css from 'styled-jsx/css';

const styles = css.global`#open-finance-banner {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), #222;
  }
  
  #open-finance-banner.stacked-banner {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
    position: relative;
    padding-bottom: 3px;
  }
  
  #open-finance-banner .bg-image-wrapper {
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
  }
  
  #open-finance-banner .bg-image-wrapper picture {
    display: flex;
    width: 100%;
    height: 100%;
  }
  
  #open-finance-banner .bg-image-wrapper picture img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }
  #open-finance-banner .fade-banner {
    opacity: 0.25;
    background: var(--Red-Red-Boston-01, #C00);
    position: absolute;
    width: 100%;
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
  }
  #open-finance-banner .fade-banner-gradiente {
    background: linear-gradient(90deg, #900 0%, rgba(153, 0, 0, 0.73) 10.94%, rgba(153, 0, 0, 0.00) 56.77%);
    width: 100%;
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
    position: absolute;
  }
  
  #open-finance-banner .santander-symbol {
    background-image: url(assets/c2c/banners/santander-symbol.svg);
    width: 100%;
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
    position: absolute;
    left: -90px;
    background-repeat: no-repeat;
    background-size: contain;
  }
  
  #open-finance-banner .text-box-position {
    margin-top: -200px;
    position: relative;
  }
  
  #open-finance-banner .text-box {
    background: #990000;
    width: 100%;
    max-width: 849px;
    padding: 24px 16px 40px 16px;
    border-radius: 4px;
    box-sizing: border-box;
    min-height: 245px;
  }
  
  #open-finance-banner .text-box .main-text {
    font-family: 'SantanderHeadline';
    font-size: 32px;
    font-weight: 400;
    line-height: 48px;
    text-align: left;
    margin-bottom: 8px;
    color: #fff;
  }
  
  #open-finance-banner .text-box .alt-text {
    font-family: 'SantanderText';
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
    color: #fff;
    max-width: 720px;
  }
  
  #open-finance-banner .text-box .btn-simulate {
    box-sizing: border-box;
    height: 48px;
    width: 200px;
  }
  
  
  @media (min-width: 992px) {
    #open-finance-banner .text-box {
      padding: 24px 47px;
      height: 245px;
    }
  
    #open-finance-banner .santander-symbol { 
      left: 0;
      width: 537px;
      height: calc(100vh - 180px);
      max-height: 436px;
      min-height: 300px;
    }
  
    #open-finance-banner .text-box .main-text {
      font-size: 40px;
      font-weight: 400;
      line-height: 60px;
      margin-bottom: 10px;
    }

    #open-finance-banner .bg-image-wrapper,
    #open-finance-banner .fade-banner,
    #open-finance-banner .fade-banner-gradiente {
      height: calc(100vh - 180px);
      max-height: 436px;
      min-height: 300px;
    }
  }
  `;

export default styles;